import { IUser } from './user.model'

export interface IWorkroom {
  id: number
  name: string
  description: string
  url: string
  isMember: boolean
  isWorkroomAdministrator: boolean
  isWorkroomOwner: boolean
  isHidden?: boolean
  workroomCategoryId: number
  ownerUser: IUser
}

export interface IWorkroomExtended extends IWorkroom {
  creationReasonText: string
}

export interface IWorkrooms {
  items: IWorkroomExtended[]
  pageIndex: number
  pageSize: number
  totalItems: number
  totalPages: number
}

export interface IWorkroomNavigationObjects {
  id: number
  name: string
}

export interface IWorkroomMember {
  firstname: string
  lastname: string
  email: string
  userId: number
  isWorkroomAdministrator: boolean
  isWorkroomOwner: boolean
  membershipDate: string
  mobilePhone: string
  phone: string
  viewProfileUrl: string
  profileImageUrl: string
}

export interface IWorkroomTypeSelect {
  value: string
  label: string
}

export interface IWorkroomPostItem {
  id: number
  url: string
  title: string
  created: string
  modified: string
  totalComments: number
}

export interface IWorkroomPosts {
  items: IWorkroomPostItem[]
  pageIndex: number
  pageSize: number
  totalItems: number
  totalPages: number
}

export interface IWorkroomPost {
  id: number
  url: string
  title: string
  createdByUser: IUser
  modified: string
  totalComments: number
  mainBody: string
  created: string
  hasCurrentUserAccessToDelete: boolean
  hasCurrentUserAccessToEdit: boolean
}

export interface IWorkroomComment {
  workroomPostId: number
  text: string
  createdByUserId: number
  createdByUser: IUser
  id: number
  created: string
  modified: string
  currentUserHasAccessToDelete: boolean
  currentUserHasAccessToEdit: boolean
}

export interface IWorkroomUserPermissions {
  updateWorkroom: boolean
  deleteWorkroom: boolean
  removeWorkroomMembership: boolean
  addWorkroomAdmin: boolean
  removeWorkroomAdmin: boolean
  createWorkroomDocument: boolean
  createWorkroomFolder: boolean
  updateWorkroomFolder: boolean
  createPostInWorkroom: boolean
  deletePostInWorkroom: boolean
  createCommentForPost: boolean
  changeWorkroomVisibility: boolean
}

export enum WorkroomItemType {
  FOLDER = 'folder',
  FILE = 'file',
}

export interface IWorkroomItem {
  id: number
  name: string
  hasCurrentUserAccessToDelete: boolean
  hasCurrentUserAccessToUpdate: boolean
  createdByUser: IUser
  created: string
  updated: string
  type: WorkroomItemType
}

export interface IWorkroomDocument extends IWorkroomItem {
  workroomFolderId: number
  url: string
}

export interface IWorkroomFolder extends IWorkroomItem {
  parentWorkroomFolderId: number
}

export type DocumentsAndFolderArray = (IWorkroomDocument | IWorkroomFolder)[]
